import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import PropTypes from 'prop-types'

import ErrorPageDom from '../../components/Screens/ErrorPage'
import * as UserActions from '../../actions/user'
import { routes } from '../../constants'

/**
 * NoEstate Container
 */
class ErrorPage extends PureComponent {
    static propTypes = {
        error: PropTypes.string.isRequired,
        errorContent: PropTypes.string.isRequired,
        errorHeader: PropTypes.string.isRequired,
        errorInfo: PropTypes.string.isRequired,
        goBack: PropTypes.func,
        infoStack: PropTypes.string.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
        location: PropTypes.shape({}).isRequired,
        logout: PropTypes.func.isRequired,
        logoutButton: PropTypes.bool,
    }

    static defaultProps = {
        goBack: null,
        logoutButton: false,
    }

    /**
     * Move login form
     */
    onClickLogout = () => {
        const { logout } = this.props
        logout()
    }

    /**
     * Render container
     */
    render() {
        const {
            errorHeader: errorHeaderProps,
            errorContent: errorContentProps,
            errorInfo: errorInfoProps,
            error: errorProps,
            infoStack: infoStackProps,
            goBack,
        } = this.props
        const { location, isAuthenticated, logoutButton } = this.props
        let errorInfo = errorInfoProps
        let error = errorProps
        let infoStack = infoStackProps
        let errorHeader = errorHeaderProps
        let errorContent = errorContentProps

        if (location) {
            errorInfo = location.errorInfo || null
            error = location.error || null
            errorHeader = location.errorHeader || errorHeaderProps
            errorContent = location.errorContent || errorContentProps
            infoStack = location.infoStack || null
        }

        if (!isAuthenticated) {
            return (
                <Redirect
                    to={{
                        pathname: routes.LOGIN,
                        state: { from: (location || {}).pathname },
                    }}
                />
            )
        }

        return (
            <ErrorPageDom
                error={error}
                errorContent={errorContent}
                errorHeader={errorHeader}
                errorInfo={errorInfo}
                goBack={goBack}
                infoStack={infoStack}
                onClickLogout={logoutButton ? this.onClickLogout : null}
            />
        )
    }
}

const mapStateToProps = ({
    user: {
        session: { isAuthenticated },
    },
}) => ({
    isAuthenticated,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...UserActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage)
